import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import { CircleX } from "lucide-react";

const TakePhotoError = ({ errorMessage, imageBuffer, onRetry, uiConfig, showImage = true }) => {
  const [imageBlob, setImageBlob] = useState(null);

  const buildClassString = (classList) => classList.filter(Boolean).join(" ");

  // Safe access
  const global = uiConfig?.Global || {};
  const textColor = global?.text?.fontColor || "#6b7280"; // default gray-500
  const cardBgColor = global?.card?.backgroundColor || "#f3f4f6"; // gray-50
  const cardOpacity = global?.card?.opacity || "1"; // default opacity
  const buttonBgColor = global?.button?.backgroundColor || "#2563eb"; // blue-600
  const buttonTextColor = global?.button?.fontColor || "#ffffff"; // white
  const pageBgColor = global?.pageContainer?.backgroundColor || "#ffffff"; // white

  useEffect(() => {
    if (imageBuffer) {
      setImageBlob(new Blob([imageBuffer], { type: "image/jpeg" }));
    }
  }, [imageBuffer]);

  return (
    <div
      style={{
        background: pageBgColor,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "1rem",
        height: "100%",
      }}
    >
      <div
        style={{
          background: cardBgColor,
          opacity: cardOpacity,
          padding: "2rem",
          borderRadius: "1rem",
          marginTop: "calc(100vh / 16)",
          marginBottom: "2rem",
        }}
      >
        <div className="flex flex-col items-center mb-8">
          <CircleX height="72" width="72" color="red" />
        </div>
        <div className="flex flex-col">
          <p className={"text-2xl font-medium text-gray-800"}>Almost there! Please try again.</p>

          <p className={"mt-4 text-lg text-gray-600"}>{errorMessage}</p>
        </div>

        <div className="flex flex-col items-center mt-8">
          {showImage && imageBlob && <img src={URL.createObjectURL(imageBlob)} alt="MyPR" className="w-60" />}
        </div>
      </div>

      <div className="flex flex-1" />

      <button
        style={{
          background: buttonBgColor,
          color: buttonTextColor,
          padding: "0.75rem 1rem",
          borderRadius: "9999px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "66.67%",
          margin: "0 auto",
          transition: "transform 0.15s ease-in-out",
        }}
        onClick={onRetry}
      >
        <span>Try Again</span>
      </button>
      <Footer
        style={{
          fontSize: "0.75rem",
          color: textColor,
          marginTop: "1rem",
        }}
      />
    </div>
  );
};

export default TakePhotoError;
